var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"twitter-widget"},[_c('v-timeline',{attrs:{"id":_vm.twitter_id,"source-type":'profile',"errorMessage":'',"options":{ 'height': _vm.twitterHeight, 'tweetLimit': 4, 'lang': 'ja' }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }